import React, { lazy, Suspense } from 'react';
export const CONFLUENCE_SEARCH_DATASOURCE_ID = '768fc736-3af4-4a8f-b27e-203602bff8ca';
const LazyConfluenceSearchConfigModal = /*#__PURE__*/lazy(() => import( /* webpackChunkName: "@atlaskit-internal_linkdatasource-confluencesearchmodal" */'./modal').then(module => ({
  default: module.ConfluenceSearchConfigModal
})));
const ConfluenceSearchConfigModalWithWrappers = props => {
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement("div", {
      "data-testid": 'confluence-search-datasource-table-suspense'
    })
  }, /*#__PURE__*/React.createElement(LazyConfluenceSearchConfigModal, props));
};
export default ConfluenceSearchConfigModalWithWrappers;